<template>
    <el-dialog
        class="driver-add-supplier-reject-dialog"
        title="司机申请处理"
        :visible.sync="visible"
        :before-close="close">
        <div class="reject-title bold-title">确定驳回司机的加入申请？</div>
        <div>
            <div class="bold-title">已选中司机：{{ this.checkedData.length }}个</div>
        </div>
        <div>
            <el-form ref="formRef" :model="formData" :rules="formRules">
                <el-form-item prop="approvalOpinion">
                    <el-input
                        v-model="formData.approvalOpinion"
                        type="textarea"
                        :rows="5"
                        placeholder="请填写驳回原因"
                    />
                </el-form-item>
            </el-form>
            <div>驳回后，司机可再次提交申请加入你的车队，重新审核。</div>
        </div>
        <span slot="footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">驳回申请</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { rejectApplyRecord } from '../../../../api/driverAddSupplier.js'

const INIT_FORM = {
    approvalOpinion: '',
}

export default {
    props: {
        checkedData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            formData: { ...INIT_FORM },
            formRules: {
                approvalOpinion: [
                    { required: true, message: '请输入驳回原因', trigger: ['blur', 'change'] },
                    { max: 100, message: '最多输入100个字', trigger: ['blur', 'change'] },
                ],
            },
        }
    },
    methods: {
        open() {
            this.visible = true
        },
        close() {
            this.formData = { ...INIT_FORM }
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate()
                this.visible = false
            })
        },
        submit() {
            this.$refs.formRef.validate().then(valid => {
                this.loading = true
                const params = {
                    applyCodeList: this.checkedData.map(item => item.applyCode),
                    ...this.formData,
                }
                rejectApplyRecord(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('驳回申请成功!')
                        this.$emit('submit')
                        this.close()
                    }
                }).finally(() => { this.loading = false })
            })
        },
    }
}
</script>
<stype lang="less">
    .driver-add-supplier-reject-dialog {
        .el-dialog__body {
            padding: 30px;
        }
        .reject-title {
            text-align: center;
            font-size: 16px;
            margin-bottom: 20px;
        }
        .bold-title {
            font-weight: bold;
        }
    }
</stype>